/*
 * Services for working with a student's flashcard sets,
 * shared to them from a teacher.
 */

import getWithXHR from 'Common/utils/getWithXHR'
import xhr from 'Common/utils/xhr'

const url = '/api/v1/students/shared_flashcard_sets'

function getStudentFlashcardSets() {
  return getWithXHR(url)
}

// Add a student to the list of students who have opened a given shared flashcard set
function markSharedFlashcardSetOpened(sharedSetId) {
  return xhr({
    url: `${url}/${sharedSetId}/open`,
    method: 'PUT',
  })
}

export default {
  getStudentFlashcardSets,
  markSharedFlashcardSetOpened,
}
